var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 1.6665C5.39683 1.6665 1.66699 5.27979 1.66699 9.73942C1.66699 14.1991 5.39683 17.8123 10.0003 17.8123C14.6038 17.8123 18.3337 14.1991 18.3337 9.73942C18.3337 5.27979 14.6038 1.6665 10.0003 1.6665ZM10.0005 16.2499C6.29422 16.2499 3.28011 13.33 3.28011 9.73946C3.28011 6.14897 6.29422 3.22904 10.0005 3.22904C13.7069 3.22904 16.721 6.14897 16.721 9.73946C16.721 13.33 13.7069 16.2499 10.0005 16.2499ZM8.38735 8.17692C8.38735 8.75309 7.90684 9.21859 7.31209 9.21859C6.71733 9.21859 6.23682 8.75309 6.23682 8.17692C6.23682 7.60075 6.71733 7.13525 7.31209 7.13525C7.90684 7.13525 8.38735 7.60075 8.38735 8.17692ZM12.6887 9.21863C13.2835 9.21863 13.764 8.75313 13.764 8.17696C13.764 7.60079 13.2835 7.13529 12.6887 7.13529C12.094 7.13529 11.6134 7.60079 11.6134 8.17696C11.6134 8.75313 12.094 9.21863 12.6887 9.21863ZM10.0005 12.8645C11.0926 12.8645 12.1242 12.3957 12.8231 11.5819C13.1087 11.2499 13.6195 11.2076 13.9588 11.481C14.3016 11.7577 14.3486 12.2492 14.063 12.5813C13.0549 13.7532 11.5731 14.4237 10.0005 14.4237C8.42793 14.4237 6.94607 13.7532 5.93801 12.5813C5.65575 12.2492 5.69943 11.7577 6.04217 11.481C6.38156 11.2076 6.89231 11.2499 7.17793 11.5819C7.87685 12.399 8.90844 12.8645 10.0005 12.8645Z",
    fill: "#2E2B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.44462998d1a0f81cc79e4ef832072d4a.svg";
export { ForwardRef as ReactComponent };